var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-service"},[_c('moduleTitle',{attrs:{"title":"加工服务"}}),_c('div',{staticClass:"dry-service-echart"},[_c('Echart',{attrs:{"option":_vm.option}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }